import { playerVisibleDocuments, type WorldDocument } from '@private-fiction/story-core';

export type VisualBindings = Record<string,string[]>;
const visualKeys = new Set(['appearance','visualdescription','physicalappearance','physicaldescription','scenedescription','sceneappearance','environmentappearance','รูปลักษณ์','ลักษณะของฉาก','รูปลักษณ์ตัวละคร']);
const normalizedKey = (key: string) => key.toLowerCase().replace(/[ _-]/g,'');
export function visualFields(document: WorldDocument): {path:string; text:string}[] {
  const safe = playerVisibleDocuments([document])[0];
  if (!safe) return [];
  const visit = (value: unknown, prefix = ''): {path:string;text:string}[] => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return [];
    return Object.entries(value).flatMap(([key,child]) => {
      const path = prefix ? `${prefix}.${key}` : key;
      return typeof child === 'string' && child.trim() ? [{path,text:child}] : visit(child,path);
    });
  };
  return visit(safe.fields);
}
export function defaultVisualPaths(document: WorldDocument): string[] {
  return visualFields(document).filter(field => field.path.split('.').some(key => visualKeys.has(normalizedKey(key)))).map(field => field.path);
}
export function visualBindingKey(document: WorldDocument): string { return document.fileTypeId || document.kind; }
export function sceneVisualPrompt(documents: readonly WorldDocument[], selected: readonly string[], bindings: VisualBindings, detail: string): string {
  const refs = playerVisibleDocuments(documents).filter(doc => selected.includes(doc.id)).flatMap(doc => {
    const paths = bindings[visualBindingKey(doc)] ?? defaultVisualPaths(doc);
    const fields = visualFields(doc).filter(field => paths.includes(field.path));
    return fields.length ? [`${doc.kind}: ${doc.title}\n${fields.map(field => field.text).join('\n')}`] : [];
  });
  const prompt = ['Illustrate this fictional scene. Use only these visual descriptions; no text labels.',...refs, detail.trim() ? `Moment and composition: ${detail.trim()}` : ''].filter(Boolean).join('\n\n');
  if (!refs.length && !detail.trim()) throw new Error('เลือกฟิลด์รูปลักษณ์ หรือระบุรายละเอียดฉากก่อนสร้างภาพ');
  if (prompt.length > 8000) throw new Error('รายละเอียดภาพยาวเกิน 8,000 ตัวอักษร กรุณาลดฟิลด์หรือรายละเอียด');
  return prompt;
}
export interface SceneImageRequest { selectedIds: string[]; bindings: VisualBindings; detail: string; model: string; size: string; requestId: string }
export interface SceneImageResult { jobId: string; runId: string; fileId: string }
